import { AutoComplete } from '../NarusMaterial/AutoComplete'

import {
  makeAutobindedInput,
  makeValidatedInput
} from './FormBuilder'

export const AutoCompleteField = props => {
  const { label, options, value, onChange, errors, ...rest } = props
  const dataFunc = text => {
    if (text && text.length > 0) {
      return Promise.resolve(
        options.filter(
          d => d.label.toLowerCase().indexOf(text.toLowerCase()) !== -1
        )
      )
    }
    return Promise.resolve(options)
  }

  const textFunc = v => v.label

  const valueFunc = v => options.filter(o => (o.value || o.code) === v)[0]

  const handle = v => {
    if (onChange) {
      if (v) {
        onChange(v.value || v.code)
      } else {
        onChange(null)
      }
    }
  }

  return (
    <AutoComplete
      {...rest}
      label={label}
      dataFunc={dataFunc}
      textFunc={textFunc}
      value={valueFunc(value)}
      onChange={handle}
      errors={errors}
    />
  )
}
export const AutoCompleteInput = makeAutobindedInput(
  makeValidatedInput(AutoCompleteField)
)
